import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-58ee5af2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-light ms-auto p-0 m-0" }
const _hoisted_2 = { class: "container-fluid p-0 m-0" }
const _hoisted_3 = {
  class: "collapse navbar-collapse",
  id: "navbarUser"
}
const _hoisted_4 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_5 = {
  class: "nav-link dropdown-toggle p-0 m-0",
  href: "#",
  id: "navbarDropdownExplore",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill" }, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))

import { nextTick, watch, ref } from 'vue'
import axios from 'axios';
import { userMenuStore } from '@/store/userMenuStore';
import { BAvatar } from 'bootstrap-vue-next';
import { generateRandomAlphaNum, cleanUser } from "@/common/common.js";
import { userMainStore } from '@/store/userMainStore';
import { userAvatarStore } from '@/store/userAvatarStore';
import { userTabStore } from '@/store/userTabStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNavbarUser',
  setup(__props) {

const main = userMainStore();
const avatarstore = userAvatarStore();
// const emit = defineEmits(['refreshMenu']);
const umenu = userMenuStore();
const utab = userTabStore();

let token = localStorage.getItem("token");
let avatar = ref(localStorage.getItem("avatar"));
let isschool = localStorage.getItem("isschool");
let iscompany = localStorage.getItem("iscompany");
// let isstudent = localStorage.getItem("isstudent");
let isteacher = localStorage.getItem("isteacher");
// let username = getCookie("uname");
// console.log("username", username);

watch(() => umenu.refreshtop, () => {
	let slm = umenu.selectedmenu;
	let navbarUser = document.querySelectorAll('#navbarUser >ul  ul.dropdown-menu li > a.dropdown-item');
	navbarUser.forEach((item) => {
		item.classList.remove("router-link-active");
		item.classList.remove("router-link-exact-active");
		if (item.getAttribute('href')?.endsWith(slm)) {
			item.classList.add("router-link-active");
			item.classList.add("router-link-exact-active");
		}
	})
});

watch(() => avatarstore.refresh, async() => {
	avatar.value = null;
	await nextTick
	avatar.value = localStorage.getItem("avatar");
});

const logOut = async () => {
	await axios
		.get('/api/v1/logout', {
			headers: { Authorization: `${token}` },
			withCredentials: true
		})
		.then(() => {
			cleanUser();
			document.location = "/login?" + generateRandomAlphaNum(5);
		});
}


// function getCookie(id: unknown) {
// 	const value = document.cookie.match('(^|;)?' + id + '=([^;]*)(;|$)');
// 	// console.log("ocument.cookie", document.cookie);
// 	return value ? unescape(value[2]) : null;

// }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", {
            class: _normalizeClass(["nav-item dropdown animatedmenu", { 'text-white' : _unref(main).isavailable }])
          }, [
            _createElementVNode("a", _hoisted_5, [
              (!_unref(avatar))
                ? (_openBlock(), _createBlock(_unref(BAvatar), {
                    key: 0,
                    rounded: "circle"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(avatar))
                ? (_openBlock(), _createBlock(_unref(BAvatar), {
                    key: 1,
                    rounded: "circle",
                    src: _unref(avatar)
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("ul", {
              class: _normalizeClass([{ 'homepage-user-menu' : _unref(main).isavailable }, "dropdown-menu dropdown-menu-end"]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(umenu).refresh=!_unref(umenu).refresh)),
              "aria-labelledby": "navbarDropdownExplore"
            }, [
              (_unref(iscompany))
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      onClick: _ctx.$scrollToTop,
                      to: "/u/my/company",
                      "aria-current": "page",
                      class: "dropdown-item tt-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.mycompany', 'My Company')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(isteacher))
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      onClick: _ctx.$scrollToTop,
                      to: "/u/tr/dashboard",
                      "aria-current": "page",
                      class: "dropdown-item tt-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.teacherdashboard', 'Teacher Dashboard')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (!_unref(iscompany))
                ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(utab).selectedtab = 'dashboard';_ctx.$scrollToTop}),
                      to: "/u/my/dashboard",
                      "aria-current": "page",
                      class: "dropdown-item tt-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.mydashboard', 'My Dashboard')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (!_unref(isschool))
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      onClick: _ctx.$scrollToTop,
                      to: "/u/my/account",
                      "aria-current": "page",
                      class: "dropdown-item tt-dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('menu.myaccount', 'My Account')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_11,
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  role: "button",
                  onClick: logOut,
                  class: "dropdown-item tt-dropdown-item"
                }, _toDisplayString(_ctx.$t('menu.signout', 'Log Out')), 1)
              ])
            ], 2)
          ], 2)
        ])
      ])
    ])
  ]))
}
}

})